import { Helmet } from "react-helmet";
import { Link, BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import CookieConsent from "./components/CookieConsent";
import Footer from "./components/Footer";
import NavBar from "./components/NavBar";
import FloatingWhatsAppButton from "./pages/FloatingWhatsAppButton";
import AboutActivities from "./pages/about/AboutActivities";
import AboutAyurveda from "./pages/about/AboutAyurveda";
import AboutContact from "./pages/about/AboutContact";
import AboutHero from "./pages/about/AboutHero";
import AboutHost from "./pages/about/AboutHost";
import AboutPanchakarma from "./pages/about/AboutPanchakarma";
import ActivitiesCards from "./pages/activities/ActivitiesCards";
import ActivitiesHero from "./pages/activities/ActivitiesHero";
import DietHero from "./pages/ayurveda/Diet/Hero";
import DietLessons from "./pages/ayurveda/Diet/Lessions";
import DietNutrition from "./pages/ayurveda/Diet/Nutrition";
import FactsDoshas from "./pages/ayurveda/Facts/Doshas";
import FactsHero from "./pages/ayurveda/Facts/Hero";
import FactsHistory from "./pages/ayurveda/Facts/History";
import FactsKnowledge from "./pages/ayurveda/Facts/Knowledge";
import FactsPhysician from "./pages/ayurveda/Facts/Physician";
import FactsWhom from "./pages/ayurveda/Facts/Whom";
import PanchakarmaConsultation from "./pages/ayurveda/Panchakarma/Consultation";
import PanchakarmaCure from "./pages/ayurveda/Panchakarma/Cure";
import PanchakarmaHero from "./pages/ayurveda/Panchakarma/Hero";
import PanchakarmaMedicine from "./pages/ayurveda/Panchakarma/Medicine";
import PanchakarmaOther from "./pages/ayurveda/Panchakarma/Other";
import Panchakarma from "./pages/ayurveda/Panchakarma/Panchakarma";
import PanchakarmaTreatments from "./pages/ayurveda/Panchakarma/Treatments";
import SpiritualHero from "./pages/ayurveda/Spiritual Travel/Hero";
import SpiritualOthers from "./pages/ayurveda/Spiritual Travel/Others";
import Booking from "./pages/booking/Booking";
import Checkout from "./pages/booking/Checkout";
import Confirmation from "./pages/booking/Confirmation";
import Search from "./pages/booking/Search";
import ContactBody from "./pages/contact-us/ContactBody";
import ContactHero from "./pages/contact-us/ContactHero";
import GallerySection from "./pages/home/GallerySection";
import HomeAyurveda from "./pages/home/HomeAyurveda";
import HomeContact from "./pages/home/HomeContact";
import HomeHeroVideo from "./pages/home/HomeHeroVideo";
import HomePanchakarma from "./pages/home/HomePanchakarma";
import HomeSrilanka from "./pages/home/HomeSrilanka";
import HomeWelcomeSection from "./pages/home/HomeWelcomeSection";
import HomeYoga from "./pages/home/HomeYoga";
import OurResorts from "./pages/home/OurResorts";
import PricingPage from "./pages/pricing/PricingPage";
import AadyaHero from "./pages/rooms/Hiru Aadya/AadyaHero";
import AadyaImages from "./pages/rooms/Hiru Aadya/AadyaImages";
import AadyaLocation from "./pages/rooms/Hiru Aadya/AadyaLocation";
import AadyaRooms from "./pages/rooms/Hiru Aadya/AadyaRooms";
import AadyaTeam from "./pages/rooms/Hiru Aadya/AadyaTeam";
import AboutAadya from "./pages/rooms/Hiru Aadya/AboutAadya";
import AadyaReviews from "./pages/rooms/Hiru Aadya/Reviews";
import AboutMudra from "./pages/rooms/Hiru Mudra/AboutMudra";
import MudraHero from "./pages/rooms/Hiru Mudra/MudraHero";
import MudraImages from "./pages/rooms/Hiru Mudra/MudraImages";
import MudraLocation from "./pages/rooms/Hiru Mudra/MudraLocation";
import MudraRooms from "./pages/rooms/Hiru Mudra/MudraRooms";
import MudraTeam from "./pages/rooms/Hiru Mudra/MudraTeam";
import MudraReviews from "./pages/rooms/Hiru Mudra/Reviews";
import AboutOm from "./pages/rooms/Hiru Om/AboutOm";
import OmHero from "./pages/rooms/Hiru Om/OmHero";
import OmImages from "./pages/rooms/Hiru Om/OmImages";
import OmLocation from "./pages/rooms/Hiru Om/OmLocation";
import OmRooms from "./pages/rooms/Hiru Om/OmRooms";
import OmTeam from "./pages/rooms/Hiru Om/OmTeam";
import OmReviews from "./pages/rooms/Hiru Om/Review";
import AboutVilla from "./pages/rooms/Hiru Villa/AboutVilla";
import VillaHero from "./pages/rooms/Hiru Villa/VillaHero";
import VillaImages from "./pages/rooms/Hiru Villa/VillaImages";
import VillaLocation from "./pages/rooms/Hiru Villa/VillaLocation";
import VillaRooms from "./pages/rooms/Hiru Villa/VillaRooms";
import VillaTeam from "./pages/rooms/Hiru Villa/VillaTeam";
import VillaReviews from "./pages/rooms/Hiru Villa/Reviews";
import TourLocations from "./pages/tours/TourLocations";
import ToursHero from "./pages/tours/ToursHero";
const SITE_URL = "https://hiruresorts.de";
const DEFAULT_SHARE_IMAGE = `${SITE_URL}/images/Hiru/public_images/DJI_0950-Enhanced-NR-Pano-1-copy.webp`;
const PAGE_SEO = {
  "/": {
    title: "Hiru Ayurveda Resorts | Ayurveda-Urlaub in Sri Lanka",
    description: "Entdecken Sie Ayurveda, Panchakarma, Yoga und erholsame Aufenthalte in den vier Hiru Ayurveda Resorts an Sri Lankas Südwestküste."
  },
  "/about": {
    title: "Über Hiru | Ayurveda Resorts in Sri Lanka",
    description: "Lernen Sie Hiru Ayurveda Resorts, unsere Gastgeber und die ayurvedischen Behandlungen und Aktivitäten in unseren Resorts kennen."
  },
  "/activities": {
    title: "Aktivitäten und Yoga | Hiru Ayurveda Resorts",
    description: "Entdecken Sie Yoga, Meditation, Qigong und weitere Aktivitäten für Körper und Geist während Ihres Ayurveda-Aufenthalts in Sri Lanka."
  },
  "/tours": {
    title: "Sri Lanka entdecken | Ausflüge mit Hiru Ayurveda Resorts",
    description: "Planen Sie Ausflüge zu Sri Lankas Landschaften, Kultur und Sehenswürdigkeiten während Ihres Aufenthalts bei Hiru Ayurveda Resorts."
  },
  "/contact-us": {
    title: "Kontakt und Anreise | Hiru Ayurveda Resorts",
    description: "Kontaktieren Sie Hiru Ayurveda Resorts für Fragen zu Ihrem Ayurveda-Aufenthalt, den Resorts, Behandlungen oder Ihrer Buchung."
  },
  "/pricing": {
    title: "Preise und Angebote | Hiru Ayurveda Resorts",
    description: "Informieren Sie sich über Zimmer, Aufenthalte und saisonale Preise in den Hiru Ayurveda Resorts in Sri Lanka."
  },
  "/hiru-villa": {
    title: "Hiru Villa | Ayurveda Resort in Maggona, Sri Lanka",
    description: "Erleben Sie Ayurveda und Panchakarma in Hiru Villa in Maggona, einem ruhigen Resort an Sri Lankas Südwestküste."
  },
  "/hiru-om": {
    title: "Hiru Om | Ayurveda Resort in Maggona, Sri Lanka",
    description: "Entdecken Sie Hiru Om in Maggona: Ayurveda, Panchakarma und eine ruhige Gartenanlage an Sri Lankas Südwestküste."
  },
  "/hiru-mudra": {
    title: "Hiru Mudra | Ayurveda Resort in Induruwa, Sri Lanka",
    description: "Finden Sie Erholung am Meer im Hiru Mudra Ayurveda Resort in Induruwa, Sri Lanka."
  },
  "/hiru-aadya": {
    title: "Hiru Aadya | Ayurveda Resort in Ahungalla, Sri Lanka",
    description: "Entdecken Sie Hiru Aadya in Ahungalla: Ayurveda-Aufenthalte nahe der Küste Sri Lankas."
  },
  "/ayurveda/interesting-facts": {
    title: "Ayurveda-Wissen und Doshas | Hiru Ayurveda Resorts",
    description: "Erfahren Sie mehr über Ayurveda, seine Geschichte, die Doshas und ayurvedische Behandlungen bei Hiru Ayurveda Resorts."
  },
  "/ayurveda/panchakarma": {
    title: "Panchakarma in Sri Lanka | Hiru Ayurveda Resorts",
    description: "Informieren Sie sich über Panchakarma, ayurvedische Anwendungen und die Behandlungsmöglichkeiten in den Hiru Resorts."
  },
  "/ayurveda/food": {
    title: "Ayurvedische Ernährung | Hiru Ayurveda Resorts",
    description: "Entdecken Sie ayurvedische Ernährung, Doshas und frisch zubereitete Küche als Teil Ihres Aufenthalts in Sri Lanka."
  },
  "/ayurveda/spiritual-journey": {
    title: "Spirituelle Reise in Sri Lanka | Hiru Ayurveda Resorts",
    description: "Verbinden Sie Ayurveda, Achtsamkeit und spirituelle Erlebnisse während Ihres Aufenthalts in Sri Lanka."
  }
};
const NO_INDEX_PATHS = new Set(["/search", "/booking", "/checkout", "/confirmation"]);

const RouteSeo = () => {
  const { pathname } = useLocation();
  const page = PAGE_SEO[pathname];
  const title = page?.title ?? "Seite nicht gefunden | Hiru Ayurveda Resorts";
  const description = page?.description ?? "Entdecken Sie Ayurveda und erholsame Aufenthalte in den Hiru Ayurveda Resorts in Sri Lanka.";
  const canonicalUrl = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;
  const robots = page && !NO_INDEX_PATHS.has(pathname) ? "index,follow" : "noindex,follow";
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: canonicalUrl,
    isPartOf: {
      "@type": "WebSite",
      name: "Hiru Ayurveda Resorts",
      url: SITE_URL
    },
    publisher: {
      "@type": "Organization",
      name: "Hiru Ayurveda Resorts",
      url: SITE_URL,
      logo: `${SITE_URL}/logo-orange.svg`
    }
  };

  return <Helmet>
    <html lang="de" />
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="robots" content={robots} />
    <link rel="canonical" href={canonicalUrl} />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="de_DE" />
    <meta property="og:site_name" content="Hiru Ayurveda Resorts" />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:url" content={canonicalUrl} />
    <meta property="og:image" content={DEFAULT_SHARE_IMAGE} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={DEFAULT_SHARE_IMAGE} />
    <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
  </Helmet>;
};

const pageSections = {
  home: [HomeHeroVideo, HomeWelcomeSection, OurResorts, GallerySection, HomeAyurveda, HomeSrilanka, HomeYoga, HomePanchakarma, HomeContact],
  about: [AboutHero, AboutAyurveda, AboutPanchakarma, AboutHost, AboutActivities, AboutContact],
  activities: [ActivitiesHero, ActivitiesCards],
  tours: [ToursHero, TourLocations],
  contact: [ContactHero, ContactBody],
  facts: [FactsHero, FactsKnowledge, FactsHistory, FactsDoshas, FactsWhom, FactsPhysician],
  panchakarma: [PanchakarmaHero, Panchakarma, PanchakarmaCure, PanchakarmaConsultation, PanchakarmaTreatments, PanchakarmaMedicine, PanchakarmaOther],
  diet: [DietHero, DietNutrition, DietLessons],
  spiritual: [SpiritualHero, SpiritualOthers],
  villa: [VillaHero, AboutVilla, VillaReviews, VillaRooms, VillaImages, VillaTeam, VillaLocation],
  om: [OmHero, AboutOm, OmReviews, OmRooms, OmImages, OmTeam, OmLocation],
  mudra: [MudraHero, AboutMudra, MudraReviews, MudraRooms, MudraImages, MudraTeam, MudraLocation],
  aadya: [AadyaHero, AboutAadya, AadyaReviews, AadyaRooms, AadyaImages, AadyaTeam, AadyaLocation]
};

const Sections = ({ components }) => components.map((Component) => <Component key={Component.name} />);

const NotFound = () => (
  <section className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
    <h1 className="font-serif text-4xl text-[#244B0C]">Seite nicht gefunden</h1>
    <Link to="/" className="font-semibold text-[#F28600] underline underline-offset-4">
      Zur Startseite
    </Link>
  </section>
);

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <RouteSeo />
        <NavBar />
        <main>
          <Routes>
            <Route path="/" element={<Sections components={pageSections.home} />} />
            <Route path="/about" element={<Sections components={pageSections.about} />} />
            <Route path="/activities" element={<Sections components={pageSections.activities} />} />
            <Route path="/tours" element={<Sections components={pageSections.tours} />} />
            <Route path="/contact-us" element={<Sections components={pageSections.contact} />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/hiru-villa" element={<Sections components={pageSections.villa} />} />
            <Route path="/hiru-om" element={<Sections components={pageSections.om} />} />
            <Route path="/hiru-mudra" element={<Sections components={pageSections.mudra} />} />
            <Route path="/hiru-aadya" element={<Sections components={pageSections.aadya} />} />
            <Route path="/ayurveda/interesting-facts" element={<Sections components={pageSections.facts} />} />
            <Route path="/ayurveda/panchakarma" element={<Sections components={pageSections.panchakarma} />} />
            <Route path="/ayurveda/food" element={<Sections components={pageSections.diet} />} />
            <Route path="/ayurveda/spiritual-journey" element={<Sections components={pageSections.spiritual} />} />
            <Route path="/search" element={<Search />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/confirmation" element={<Confirmation />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FloatingWhatsAppButton />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;
